<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2418"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2422"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2444"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2442" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2482"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2480" /></clipPath></defs><g
     id="g2424"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2426"
       transform="translate(30,175.5747)"><path
         d="M 0,0 V 283.468"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path2428" /></g><g
       id="g2430"
       transform="translate(30,52.6597)"><path
         d="M 0,0 V 87.915"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path2432" /></g><g
       id="g2434"
       transform="translate(458.915,30)"><path
         d="M 0,0 H -406.17"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path2436" /></g><g
       id="g2438"><g
         id="g2440"
         clip-path="url(#clipPath2444)"><g
           id="g2446"
           transform="translate(482,223.9424)"><path
             d="M 0,0 V -171.134"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2448" /></g><g
           id="g2450"
           transform="translate(482,459.2129)"><path
             d="M 0,0 V -200.271"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2452" /></g><g
           id="g2454"
           transform="translate(209.8726,482)"><path
             d="M 0,0 H 249.34"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2456" /></g><g
           id="g2458"
           transform="translate(53.085,482)"><path
             d="M 0,0 H 121.788"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2460" /></g></g></g><path
       d="M 180,332 H 90 v 90 h 90 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path2462" /><path
       d="m 90,92 h 90 v 90 H 90 Z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path2464" /><path
       d="m 301,92 h -90 v 90 h 90 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path2466" /><path
       d="m 422,92 h -90 v 90 h 90 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path2468" /><g
       id="g2470"
       transform="translate(257.3193,332)"><path
         d="m 0,0 h -47.319 v 90 h 212 V 0 H 35"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path2472" /></g><path
       d="M 422,212 H 90 v 90 h 332 z"
       style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
       id="path2474" /><g
       id="g2476"><g
         id="g2478"
         clip-path="url(#clipPath2482)"><g
           id="g2484"
           transform="translate(464.5,459.5)"><path
             d="m 0,0 h 35 c 2.761,0 5,2.239 5,5 v 35 c 0,2.761 -2.239,5 -5,5 H 0 c -2.761,0 -5,-2.239 -5,-5 V 5 C -5,2.239 -2.761,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2486" /></g><g
           id="g2488"
           transform="translate(464.5,7.5)"><path
             d="m 0,0 h 35 c 2.761,0 5,2.239 5,5 v 35 c 0,2.761 -2.239,5 -5,5 H 0 c -2.761,0 -5,-2.239 -5,-5 V 5 C -5,2.239 -2.761,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2490" /></g><g
           id="g2492"
           transform="translate(12.5,459.5)"><path
             d="m 0,0 h 35 c 2.761,0 5,2.239 5,5 v 35 c 0,2.761 -2.239,5 -5,5 H 0 c -2.761,0 -5,-2.239 -5,-5 V 5 C -5,2.239 -2.761,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2494" /></g><g
           id="g2496"
           transform="translate(12.5,7.5)"><path
             d="m 0,0 h 35 c 2.761,0 5,2.239 5,5 v 35 c 0,2.761 -2.239,5 -5,5 H 0 c -2.761,0 -5,-2.239 -5,-5 V 5 C -5,2.239 -2.761,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2498" /></g><g
           id="g2500"
           transform="translate(120,392)"><path
             d="M 0,0 H 30"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2502" /></g><g
           id="g2504"
           transform="translate(120,362)"><path
             d="M 0,0 H 30"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2506" /></g><g
           id="g2508"
           transform="translate(120,272)"><path
             d="M 0,0 H 271.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2510" /></g><g
           id="g2512"
           transform="translate(120,242)"><path
             d="M 0,0 H 271.5"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2514" /></g><g
           id="g2516"
           transform="translate(241,152)"><path
             d="M 0,0 H 30"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2518" /></g><g
           id="g2520"
           transform="translate(241,122)"><path
             d="M 0,0 H 30"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2522" /></g></g></g></g></svg>
</template>
